import { CommonModule, DOCUMENT } from '@angular/common';
import { Component, OnInit, inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

import { FeatureFlagService } from '@digital-platform/util-feature-flags/services';

@Component({
  selector: 'digital-platform-feature-einstein-chatbot',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './feature-einstein-chatbot.component.html',
  styleUrls: ['./feature-einstein-chatbot.component.css'],
})
export class FeatureEinsteinChatbotComponent implements OnInit {
  private document = inject(DOCUMENT);
  private featureFlagService = inject(FeatureFlagService);
  private translateService = inject(TranslateService);
  private isFeatureEnabled = false;

  ngOnInit(): void {
    this.isFeatureEnabled = this.featureFlagService.getValue(
      'chatbot-neuraflash'
    ) as boolean;

    if (this.isFeatureEnabled) {
      const scriptElement = this.document.createElement('script');

      this.translateService
        .get('FEATURE.EINSTEIN.CHATBOT.NEURAFLASH_URL')
        .subscribe((url: string) => {
          scriptElement.setAttribute('src', url);

          this.document.body.appendChild(scriptElement);
        });
    }
  }
}
